import styled from 'styled-components';

const TitleContainer = styled.div`
  flex: 1 0 auto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #262626;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    max-width: 700px;
  } 
`;

export default TitleContainer;
